import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
// config
//
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { superadmindashboardRoutes } from './superadmin-dashboard';
import { admindashboardRoutes } from './organizer-dashboard';

import { componentsRoutes } from './components';


// ----------------------------------------------------------------------

export default function Router() {


  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage dashboard={false} />
        </MainLayout>
      ),

    },
    // {
    //   path: "/result",
    //   element: <GiveawayResultSlotMachine />
    // },
   

    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,
    //  Dashboard routes
    ...dashboardRoutes,


    //super-admin dashboard
    ...superadmindashboardRoutes,

    //user-dashboard
    ...admindashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,



    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
